// Filtra elementos de una lista en el DOM usando solo texto y sin requests remotos.
// Uso:
// <div data-controller="list-filter">
//   <input data-list-filter-target="query" data-action="input->list-filter#apply">
//   <ul>
//     <li data-list-filter-target="item">Texto a buscar</li>
//   </ul>
//   <div data-list-filter-target="empty" hidden>Sin resultados</div>
// </div>
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["query", "item", "empty"]

  connect() {
    // Aplicamos el filtro inicial (mostrar todo)
    this.apply()
  }

  // Aplica el filtrado según el valor del input
  apply() {
    const q = (this.hasQueryTarget ? this.queryTarget.value : "").trim().toLowerCase()

    let visibleCount = 0
    this.itemTargets.forEach((el) => {
      const txt = (el.textContent || "").toLowerCase()
      const match = q === "" || txt.includes(q)

      // Usamos utilidades de Bootstrap para mostrar/ocultar
      el.classList.toggle("d-none", !match)

      if (match) visibleCount += 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = visibleCount !== 0
    }
  }

  // Limpia el filtro y vuelve a mostrar todos los elementos
  clear() {
    if (this.hasQueryTarget) {
      this.queryTarget.value = ""
      this.apply()
      this.queryTarget.focus()
    }
  }
}

